<div class="main-full p-0 d-flex justify-content-center align-items-center flex-column">
    <h2 class="mb-3 message">
        {{message}}
    </h2>
    <app-loading-spinner *ngIf="loading" [widthHeightPx]="100"></app-loading-spinner>
</div>
